import O from "lodash-es/debounce";
import V from "lodash-es/get";
import { toValue as u, computed as c, ref as N, watch as L, reactive as I, nextTick as w, readonly as E } from "vue";
import { DECIMAL_PRECISION as A, DEBOUNCE as q } from "./constants.js";
import { t as f } from "./locale.js";
import { i as l } from "./isDefined-DzVx0B6k.js";
import D from "lodash-es/round";
function j(e) {
  return e && e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function C(e) {
  return e;
}
function F(e, t) {
  t = t || {};
  const i = t.delimiter || ".", o = t.maxDepth, s = t.transformKey || C, m = {};
  function v(h, y, g) {
    g = g || 1, Object.keys(h).forEach(function(p) {
      const r = h[p], x = t.safe && Array.isArray(r), n = Object.prototype.toString.call(r), a = j(r), b = n === "[object Object]" || n === "[object Array]", d = y ? y + i + s(p) : s(p);
      if (!x && !a && b && Object.keys(r).length && (!t.maxDepth || g < o))
        return v(r, d, g + 1);
      m[d] = r;
    });
  }
  return v(e), m;
}
function Y(e = {}) {
  return {
    name: "email",
    validator(t) {
      return !l(t) || typeof t == "string" && /^\S+@\S+\.\S+$/.test(t);
    },
    message: e.message || f("ll.validation.email")
  };
}
function _(e) {
  return {
    name: "maxLength",
    validator(t) {
      const i = u(e.max), o = u(t);
      if (!l(o))
        return !0;
      let s = String(o);
      return e.trim && (s = s.trim()), s.length <= i;
    },
    message: e.message || (() => f("ll.validation.maxLength", { max: String(u(e.max)) }))
  };
}
function z(e) {
  return {
    name: "maxValue",
    validator(t) {
      const i = u(e.max);
      return !l(t) || Number(t) <= i;
    },
    message: e.message || (() => f("ll.validation.maxValue", { max: String(u(e.max)) }))
  };
}
function G(e) {
  return {
    name: "minLength",
    validator(t) {
      const i = u(e.min), o = u(t);
      if (!l(o))
        return !0;
      let s = String(o);
      return e.trim && (s = s.trim()), s.length >= i;
    },
    message: e.message || (() => f("ll.validation.minLength", { min: String(u(e.min)) }))
  };
}
function H(e) {
  return {
    name: "minValue",
    validator(t) {
      const i = u(e.min);
      return !l(t) || Number(t) >= i;
    },
    message: e.message || (() => f("ll.validation.minValue", { min: String(u(e.min)) }))
  };
}
function J(e) {
  return {
    name: "pattern",
    validator(t) {
      const i = u(t);
      return !l(i) || e.regex.test(String(i));
    },
    message: () => {
      if (typeof e.message != "string" || !e.message.trim())
        throw new Error(
          'The "pattern" ruleFactory requires a custom message informing the user of the required pattern.'
        );
      return e.message;
    }
  };
}
function Q(e = {}) {
  return {
    name: "positiveNumber",
    validator(t) {
      return !l(t) || Number(t) > 0;
    },
    message: e.message || f("ll.validation.positiveNumber")
  };
}
function X(e = {}) {
  return {
    name: "price",
    validator(t) {
      const i = Number(t);
      return !l(t) || i !== 1 / 0 && i >= 0 && i === D(i, A.CURRENCY);
    },
    message: e.message || f("ll.validation.price")
  };
}
function Z(e = {}) {
  return {
    name: "required",
    validator(t) {
      return l(typeof t == "string" ? t.trim() : t);
    },
    message: e.message || f("ll.validation.required")
  };
}
function W(e = {}) {
  return {
    name: "wholeNumber",
    validator(t) {
      return !l(t) || Number.isInteger(Number(t)) && Number(t) >= 0;
    },
    message: e.message || f("ll.validation.wholeNumber")
  };
}
function ee({
  rules: e,
  values: t
}) {
  const o = c(() => Object.keys(F(e, { safe: !0 }))).value.reduce(
    (n, a) => {
      const b = N(V(u(t), a)), d = (T) => {
        b.value = V(u(t), T);
      }, S = O(() => {
        d(a);
      }, q.FAST);
      return L(
        () => V(u(t), a),
        () => {
          S();
        }
      ), n[a] = B({
        fieldName: a,
        fieldValue: b,
        flush: () => {
          S.cancel(), d(a);
        },
        rules: V(e, a)
      }), n;
    },
    {}
  ), s = c(() => Object.values(o)), m = c(() => s.value.some((n) => n.errors.length > 0)), v = c(() => s.value.some((n) => n.isTouched)), h = c(() => s.value.filter((n) => n.isDirty));
  return I({
    validate: async function({ preventScroll: n } = {}) {
      if (s.value.forEach((a) => {
        a.setTouched(!1), a.setTouched(!0);
      }), await w(), m.value && !n) {
        const a = Object.entries(o).find(([, S]) => S.errorMessage), b = (a == null ? void 0 : a[0]) || "", d = document == null ? void 0 : document.querySelector(`[name=${b}]`);
        d && d.scrollIntoView({ behavior: "smooth" });
      }
      return !m.value;
    },
    getError: function(n) {
      var a;
      return ((a = o[n]) == null ? void 0 : a.errorMessage) || "";
    },
    touch: function(n) {
      if (!o[n])
        throw new Error(`In touch: fieldName "${n}" does not exist in the validation fields.`);
      o[n].setTouched();
    },
    setAllUntouched: async function() {
      await w(), s.value.forEach((n) => {
        n.setTouched(!1);
      });
    },
    setInitialValues: function(n) {
      s.value.forEach((a) => {
        a.setInitialValue(n[a.name]);
      });
    },
    fields: o,
    dirtyFields: h,
    hasErrors: m,
    someTouched: v
  });
}
function B({
  fieldName: e,
  fieldValue: t,
  rules: i,
  flush: o
}) {
  const s = N(t.value), m = N(!1), v = c(() => (t.value ?? "") !== (s.value ?? "")), h = c(() => m.value ? i.map((r) => ({
    fieldName: e,
    ruleName: r.name,
    isValid: r.validator(t.value),
    message: typeof r.message == "function" ? r.message(t.value) : r.message
  })) : []), y = c(
    () => h.value.filter((r) => !r.isValid).map((r) => ({
      ruleName: r.ruleName,
      message: r.message
    }))
  );
  function g(r = !0) {
    o(), m.value = r;
  }
  function p(r) {
    s.value = r;
  }
  return I({
    name: e,
    currentValue: E(t),
    initialValue: E(s),
    isTouched: E(m),
    isDirty: E(v),
    errorMessage: c(() => {
      var r, x;
      return ((x = (r = y.value) == null ? void 0 : r[0]) == null ? void 0 : x.message) || "";
    }),
    errors: y,
    setInitialValue: p,
    setTouched: g
  });
}
export {
  ee as default,
  Y as email,
  l as isDefined,
  _ as maxLength,
  z as maxValue,
  G as minLength,
  H as minValue,
  J as pattern,
  Q as positiveNumber,
  X as price,
  Z as required,
  W as wholeNumber
};
//# sourceMappingURL=useValidation.js.map
